module.exports = __webpack_public_path__ + "img/with_phone.c516c8a1.png";